import BottomSheetWebViewWrapper from '@di-shared/features/common/BottomSheetWebViewWrapper';
import TagFormBottomSheet from '@di-shared/features/history/tags/TagFormBottomSheet';
import {TagFormBottomSheetData} from '@di-shared/features/history/tags/TagFormBottomSheet';

const BOTTOM_SHEET_FALLBACK_HEIGHT = 360;

export default function HistoryTagFormBottomSheetPage() {
  const {initialTagName = ''} = ((window as any).data || {}) as TagFormBottomSheetData;

  return (
    <BottomSheetWebViewWrapper bottomSheetFallbackHeight={BOTTOM_SHEET_FALLBACK_HEIGHT}>
      <TagFormBottomSheet initialTagName={initialTagName} />
    </BottomSheetWebViewWrapper>
  );
}
